/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';

import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupMembership from 'entities/GroupMembership';
import GroupMembershipStore from 'stores/GroupMembershipStore';
import BatchRoleCorrectionModal from 'users/components/BatchRoleCorrectionModal.jsx';

const zeroRolesFilter = (m: GroupMembership) => {
  const orgView = m.getOrgAffiliationView();
  return !!orgView && orgView.roles.length === 0;
};

type Props = {
  group: Group,
  onRequestHide: () => any, // From mountModal
  onClose: ?Function,
};

type State = {
  unknownRoles: GroupMembership[],
  loading: bool,
}

class UnknownRolesModalContainer extends React.Component {
  props: Props;

  state: State;

  state = {
    unknownRoles: [],
    loading: true,
  };

  static getStores() {
    return [GroupMembershipStore];
  }

  static calculateState(prevState: State, props: Props) {
    const all = GroupMembershipStore.getGroupMembershipsForGroup(props.group.id);

    return {
      unknownRoles: all.filter(zeroRolesFilter),
    };
  }

  componentWillMount() {
    GroupActions.loadGroupMemberships(this.props.group, {
      perPage: 500,
      role: 'unknown',
    }).then(() => this.setState({ loading: false }))
      .catch(err => console.error('Group memberships load failure', err));
  }

  render() {
    const { group, onRequestHide, onClose } = this.props;
    const { unknownRoles, loading } = this.state;
    return (
      <BatchRoleCorrectionModal
        group={group}
        onRequestHide={onRequestHide}
        onClose={onClose}
        groupMemberships={unknownRoles}
        loading={loading}
      />
    );
  }
}

export default Container.create(UnknownRolesModalContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/components/UnknownRolesModalContainer.jsx